import {BrowserRouter as Router, Redirect} from 'react-router-dom';
import React, {useMemo} from 'react';
import {Route, Switch, useRouteMatch} from 'react-router';
import {AuthRoute} from '../utilities/session-management/auth-route';
import {LoginRoute} from '../utilities/session-management/login-route';
import {LoginCallbackPage, OidcSilentRenewPage} from '../utilities/session-management/oidc/oidc-login-callback-page';
import {I18nextProvider} from 'react-i18next';
import i18n from '../utilities/i18n';
import IkkeBetalt from './ikkeBetalt/ikkebetalt';
import UgyldigJeger from './ugyldigjeger/ugyldigjeger';
import {UmyndigJeger} from './umyndigjeger/umyndigjeger';
import {InternalServerError} from './internalservererror/internalservererror';
import {LisensProvider} from './lisenscontext/lisenscontext';
import LisensTitel from './lisenstitle/lisenstitel';
import CallbackHandler from '../utilities/CallbackHandler';
import {AuthProvider} from 'react-oidc-context';
import {idPortenUserManager} from '../IdPortenUserManager';

const onSigninCallback = ()=> {
  window.history.replaceState(
      {},
      document.title,
      window.location.pathname
  );
  window.location.replace(`${window.location.origin}/nb`);
};



const AuthenticatedRoutes = () => {
  const routeMatch = useRouteMatch();
  const basePath = useMemo(() => {
    if (routeMatch.path === '/') {
      return '';
    } else {
      return routeMatch.path;
    }
  }, [routeMatch]);

  return (
    <LisensProvider>
      <Switch>
        <LoginRoute exact path={`${basePath}/:lang/login`}/>
        <Route path={`${basePath}/login`}><Redirect to={`${basePath}/${i18n.language}/login`}/></Route>
        <AuthRoute exact path={`${basePath}/:lang/umyndig`} component={UmyndigJeger}/>
        <AuthRoute exact path={`${basePath}/:lang/internalservererror`} component={InternalServerError}/>
        <AuthRoute exact path={`${basePath}/:lang/ikkebetalt`} component={IkkeBetalt}/>
        <AuthRoute exact path={`${basePath}/:lang/ugyldig`} render={() => <UgyldigJeger isVarsel={false}/>}/>
        <AuthRoute exact path={`${basePath}/:lang/varsel`} render={() => <UgyldigJeger isVarsel={true}/>}/>
        <AuthRoute exact path={`${basePath}/:lang`} component={LisensTitel}/>
        <Route path='/'><Redirect to={`${basePath}/${i18n.language}`}/></Route>
      </Switch>
    </LisensProvider>
  );
};

export const Root = () => (
    <AuthProvider userManager={idPortenUserManager}
                  onSigninCallback={onSigninCallback}
    >
  <I18nextProvider i18n={i18n}>
    <Router>
      <Switch>
        <Route path='/login/idporten/callback' element={<CallbackHandler />} />
        <Route exact path='/post-signin' component={LoginCallbackPage}/>
        <Route exact path='/silent-renew' component={OidcSilentRenewPage}/>
        <Route exact path='/error-page' component={OidcSilentRenewPage}/>
        <Route path='/utenlandsk'>
          <AuthenticatedRoutes/>
        </Route>
        <AuthenticatedRoutes/>
      </Switch>
    </Router>
  </I18nextProvider>
      </AuthProvider>
);
